// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2Tng0","colMaxWidth":"Table_colMaxWidth__YezfK"};